
export default {
  name: 'UndoToastComponent',
  data: () => ({
    message: '',
    showToast: false,
    toastTimeout: 0
  }),
  methods: {
    show(message?: string) {
      this.showToast = true;
      this.message = message ?? 'Ação realizada';

      this.toastTimeout = setTimeout(() => {
        this.close();
      }, 5000)
    },
    undo() {
      this.$emit('onUndoClick');
      this.close();
    },
    close() {
      this.showToast = false;
      clearTimeout(this.toastTimeout);
      this.$emit('onToastClose');
    }
  },
  expose: ['show']
}
